import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const FilterTitle=styled(Typography)(({theme})=>({
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: '32px',
    [theme.breakpoints.down('xs')]: {
        display: 'block'
    },
}));